import { Slide } from "react-awesome-reveal";
import { AiFillGithub, AiFillLinkedin, AiOutlineLink } from 'react-icons/ai'

function TeamCard({ person }) {
    const { photo, name, position, about, delay, github, linkedin, social, social__icon, portfolio } = person;
    return (
        <>
            <Slide delay={delay}>
                <div className='team__card__container'>
                    <div className='team__card__photo'>
                        <img src={photo} alt="" />
                    </div>
                    <div className="team__card__content">
                        <h2>{name}</h2>
                        <p>{position}</p>
                        <p className='team__about'>{about}</p>
                        <div className='team__icons'>
                            <a href={github} target='_blank' rel="noreferrer"><i><AiFillGithub /></i></a>
                            <a href={linkedin} target='_blank' rel="noreferrer"><i><AiFillLinkedin /></i></a>
                            <a href={social} target='_blank' rel="noreferrer"><i>{social__icon}</i></a>
                            <a href={portfolio} target='_blank' rel="noreferrer"><i><AiOutlineLink /></i></a>
                        </div>
                    </div>
                </div>
            </Slide>
        </>
    )
}

export default TeamCard
